<template>
    <div class="placeInfo-page">
        <div class="view">
            <div class="form-body" v-if="currentData.id != undefined">
                <form-title required>扩展信息</form-title>
                <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="150px" class="demo-ruleForm">
                    <div class="project-box">
                        <el-form-item label="总建筑面积（平米）" prop="buildingArea" style="width:50%;">
                            <el-input v-model.number="ruleForm.buildingArea" :disabled="isAdd == 3" />
                        </el-form-item>
                        <el-form-item label="总制冷面积（平米）" prop="kongtiaoArea" style="width:50%;">
                            <el-input v-model.number="ruleForm.kongtiaoArea" :disabled="isAdd == 3" />
                        </el-form-item>
                        <el-form-item label="总制热面积（平米）" prop="cainuanArea" style="width:50%;">
                            <el-input v-model.number="ruleForm.cainuanArea" :disabled="isAdd == 3" />
                        </el-form-item>
                        <el-form-item label="制冷热容积（立米）" prop="rongjiCube" style="width:50%;">
                            <el-input v-model.number="ruleForm.rongjiCube" :disabled="isAdd == 3" />
                        </el-form-item>
                        <el-form-item label="平段电价 （元/度）" prop="priceNormal" style="width:50%;">
                            <el-input v-model.trim="ruleForm.priceNormal" :disabled="isAdd == 3" />
                        </el-form-item>
                        <el-form-item label="项目大屏幕（可选）" prop="screen" style="width:50%;">
                            <el-input v-model.trim="ruleForm.screen" :disabled="isAdd == 3" />
                        </el-form-item>
                    </div>
                </el-form>
                <!--
                <div>&nbsp;</div>
                <div>
                    <el-button size="mini" icon="el-icon-plus" type="primary" @click="add" style="background-color:#409eff;">新增电价</el-button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <el-button size="mini" icon="el-icon-sort" type="info" @click="priceList('sortPrice')" style="background-color:#409eff;">按电价排序</el-button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <el-button size="mini" icon="el-icon-sort" type="info" @click="priceList('sortMonth')" style="background-color:#409eff;">按月份排序</el-button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <el-button size="mini" icon="el-icon-document-checked" type="info" @click="rangeCheck()" style="background-color:#409eff;" :loading="isLoading">电价设置检查</el-button>
                </div>
                -->
                <form-title>电价信息</form-title>
                <DiluTable :list="tableData" :tableConfig="tableConfig">
                    <el-table-column prop="stype" label="电价时段" width="100" align="left">
                        <template slot-scope="scope">
                            <span v-if="scope.row.stype == 'jian'">尖</span>
                            <span v-if="scope.row.stype == 'feng'">峰</span>
                            <span v-if="scope.row.stype == 'ping'">平</span>
                            <span v-if="scope.row.stype == 'gu'">谷</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dayStart" label="开始日期" width="150" align="left" />
                    <el-table-column prop="dayEnd" label="结束日期" width="150" align="left" />
                    <el-table-column prop="timeStart" label="开始时间" width="100" align="left" />
                    <el-table-column prop="timeEnd" label="结束时间" width="100" align="left" />                        
                    <el-table-column prop="price" label="电价" width="100" align="left" />
                    <el-table-column prop="createdAt" label="创建时间" width="150" align="left" />
                    <el-table-column prop="updatedAt" label="更新时间" width="150" align="left" />
                    <!--
                    <el-table-column label="操作" align="center" width="200" v-if="isAdd!=3">
                        <template slot-scope="scope">
                            <div class="table-operation">
                                <el-button @click="edit(scope.row)" type="text">编辑</el-button>
                                <el-button @click="remove(scope.row)" type="text">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    -->
                </DiluTable>

                <div>&nbsp;</div>
                <form-title required>建筑设置</form-title>
                <el-tree class="tree" ref="tree" :data="dataList" node-key="id" :props="defaultProps"
                    @node-click="treeClick" :expand-on-click-node="false" default-expand-all>
                    <span class="custom-tree-node show-hide" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span style="display:none;">
                            <i v-if="isAdd != 3" @click="() => appendNode(data)" class="el-icon-plus" style="margin-right:10px;" title="增加"></i>
                            <i v-if="data.id !== 1 &&isAdd != 3" @click="() => editNode(data)" class="el-icon-edit" style="margin-right:10px;" title="编辑"></i>
                            <i v-if="data.id !== 1 &&isAdd != 3" @click="() => removeNode(data)" class="el-icon-delete" title="删除"></i>
                        </span>
                    </span>
                </el-tree>

                <form-title>客户档案</form-title>
                <dilu-uploadfile v-show="isAdd != 3" :limit="1" @success="getfileUrl" style="margin: 20px 10px;width: 15vw;" />
                <div>&nbsp;</div>
                <span v-if="isAdd == '1' || isAdd == '2'" slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submit">保存</el-button>
                    <el-button type="text" @click="resetForm">重置</el-button>
                </span>
            </div>
            <div v-else>
                <el-empty>
                    <span>项目未新建，需新建项目后操作</span>
                    <el-button type="text" @click="goProjectTab()">去新建项目</el-button>
                </el-empty>
            </div>
        </div>

        <!-- 查看和编辑建筑列表 -->
        <BuildAddModule :id="id" :parentId="parentId" :name="name" :orgVisible="orgVisible" :project="ruleForm.projectCode" @handleClose="handleClose" @listOrg="listOrg" />

         <!-- 新增和编辑电价 -->
        <PriceAddModule :priceVisible="priceVisible" :project="ruleForm.projectCode" :priceData="priceData" @handleClose="handleClose" @priceList="priceList" />

    </div>
</template>


<script>
import { mapState } from "vuex";
import BuildAddModule from "./buildAddModule.vue";
import PriceAddModule from "./priceAddModule.vue";
import DiluUploadfile from "@/components/public/dilu-uploadfile.vue";
import DiluTable from "@/components/public/dilu-table.vue";
import FormTitle from "./FormTitle.vue";

export default {
    data() {
        return {
            title: "新建项目",
             tableConfig: {
                isTree: false,
                isPage: false,
            },
            ruleForm: {
                id: null,           //自增ID
                projectCode: "",    //项目编号
                projectName: "",    //项目名称
                status: 10,         //项目状态（10：正常使用，20：在建，30：交付）
                orgId: "",          //归属部门
                contactPerson: "",  //客户姓名
                contactPhone: "",   //联系电话
                buildingType: "",   //建筑类型
                buildingArea: 0,    //住宅面积
                kongtiaoArea: 0,    //制冷面积
                cainuanArea: 0,     //制热面积
                rongjiCube: 0,      //冷热容积
                country: "中国",    //国家
                province: "",       //省份
                city: "",           //城市
                area: "",           //区县
                address: "",        //详细地址
                priceNormal: 0.55,  //正常电价
                screen: null,       //项目大屏
                remark: "",         //租户备注
            },
            isLoading: false,
            tableData: [],
            isAdd: 1,
            currentData: {},
            dataList: [],
            parentId: null,
            id: null,
            name: null,
            priceData: {},
            priceVisible: false,
            orgVisible: false,
            defaultProps: {
                children: "nodeList",
                label: "name"
            },
            rules: {
                projectName: [
                    {
                        required: true,
                        message: "请填写项目名称",
                        trigger: "blur",
                    }
                ]
            },
        };
    },
    components: {
        DiluTable,
        BuildAddModule,
        PriceAddModule,
        DiluUploadfile,
        FormTitle
    },
    computed: {
        ...mapState(["projectCurrentRowData"])
    },
    mounted() {
        const { isAdd } = this.$route.query;
        this.isAdd = isAdd;
        this.currentData = this.projectCurrentRowData;
        if (this.currentData.id != undefined) {
            this.showInit();
            this.listOrg();
        }
        this.priceList("sortPrice");
    },
    methods: {
        rangeCheck() {
            this.isLoading=true;
            var params={
                project: this.ruleForm.projectCode
            }
            this.request.electricityCheck(params).then((res) => {
                this.isLoading=false;
                if (res.code!=0) {
                    this.$confirm(res.msg, "提醒", {
                        confirmButtonText: "知道了",
                        type: "warning",
                    }).then(() => {});
                } else {
                    this.$message({
                        type: "success",
                        message: "你很棒没有错误哦！",
                    });
                }
            });
        },
        priceList(sortBy) {
            if (sortBy==null) {
                sortBy="sortPrice";
            }
            if (this.ruleForm.projectCode!=null&&this.ruleForm.projectCode!="") {
                var params={
                    project: this.ruleForm.projectCode,
                    sortBy: sortBy
                }
                this.request.electricityList(params).then((res) => {
                    this.tableData = res.data;
                });
            }
        },
        add() {
            this.priceVisible=true;
            this.priceData={};
        },
        edit(e) {
            this.priceVisible=true;
            this.priceData=e;
        },
        remove(e) {
            this.$confirm("确定删除该电价数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                var params = {
                    "id":e.id
                };
                this.request.electricityDel(params).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "删除成功",
                        });
                        this.priceList("sortPrice");
                    }
                });
            });
        },
        goProjectTab() {
            this.$emit('update:msg', 'baseInfo');
        },
        //初始显示
        showInit() {
            if (this.isAdd == 1) {
                this.title = "新建项目";
                this.ruleForm.projectCode = this.currentData.projectCode;    //项目编号
                this.ruleForm.id = null;           //自增ID
                this.ruleForm.projectName = "";    //项目名称
                this.ruleForm.status = 20;         //项目状态（10：正常使用，20：在建，30：交付）
                this.ruleForm.orgId = [];          //归属部门
                this.ruleForm.contactPerson = "";  //客户姓名
                this.ruleForm.contactPhone = "";   //联系电话
                this.ruleForm.buildingType = [];   //建筑类型
                this.ruleForm.buildingArea = 0;    //住宅面积
                this.ruleForm.kongtiaoArea = 0;    //空调面积
                this.ruleForm.cainuanArea = 0;     //供暖面积
                this.ruleForm.rongjiCube = 0;      //冷热容积
                this.ruleForm.country = "中国";    //国家
                this.ruleForm.province = "";       //省份
                this.ruleForm.city = "";           //城市
                this.ruleForm.area = "";           //区县
                this.ruleForm.address = "";        //详细地址
                this.ruleForm.priceNormal = 0.55;  //正常电价
                this.ruleForm.screen = "";         //项目大屏
                this.ruleForm.remark = "";         //项目备注

            } else if (this.isAdd == 2 || this.isAdd == 3) {
                if (this.isAdd == 2) {
                    this.title = "编辑项目";
                } else {
                    this.title = "查看项目";
                }
                this.ruleForm.id = this.currentData.id;                        //自增ID
                this.ruleForm.projectCode = this.currentData.projectCode;      //项目编号
                this.ruleForm.projectName = this.currentData.projectName;      //项目名称
                this.ruleForm.status = this.currentData.status;                //项目状态（10：正常使用，20：在建，30：交付）
                this.ruleForm.orgId = this.currentData.orgId;                  //归属部门
                this.ruleForm.contactPerson = this.currentData.contactPerson;  //客户姓名
                this.ruleForm.contactPhone = this.currentData.contactPhone;    //联系电话
                this.ruleForm.buildingType = this.currentData.buildingType;    //建筑类型
                this.ruleForm.buildingArea = this.currentData.buildingArea;    //建筑面积
                this.ruleForm.kongtiaoArea = this.currentData.kongtiaoArea;    //空调面积
                this.ruleForm.cainuanArea = this.currentData.cainuanArea;      //供暖面积
                this.ruleForm.rongjiCube = this.currentData.rongjiCube;        //冷热容积
                this.ruleForm.country = this.currentData.country;              //国家
                this.ruleForm.province = this.currentData.province;            //省份
                this.ruleForm.city = this.currentData.city;                    //城市
                this.ruleForm.area = this.currentData.area;                    //区县
                this.ruleForm.address = this.currentData.address;              //详细地址
                this.ruleForm.priceNormal = this.currentData.priceNormal;      //正常电价
                this.ruleForm.screen = this.currentData.screen;                //项目大屏
                this.ruleForm.remark = this.currentData.remark;                //归属部门
            }
    
        },
        getfileUrl(val) {
            //console.log(val);
            this.ruleForm.cadFile = val.url;
        },

        listOrg() {
            // { project: this.ruleForm.projectCode }
            this.request.placeList({ project: this.ruleForm.projectCode }).then((res) => {
                this.dataList = [res.data];
                //console.log(res.data)
            });
        },
        //点击节点触发
        treeClick(e) {
            this.params.orgId = e.id;
            this.accountManagementList();
        },

        // 新增树节点
        appendNode(data) {
            this.id = null;
            this.name = null;
            this.parentId = data.id;
            this.orgVisible = true;
        },
        // 编辑树节点
        editNode(data) {
            this.id = data.id;
            this.parentId = null;
            this.name = data.name;
            this.orgVisible = true;
        },
        // 删除树节点
        removeNode(data) {
            this.$confirm("确定删除选中建筑？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                var params = {};
                params['id'] = data.id;
                params['project'] = this.ruleForm.projectCode;

                this.request.placeDel(params).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "删除成功",
                        });
                        this.listOrg();
                    }
                });
            });
        },
        resetForm() {
            this.$refs["ruleForm"].resetFields();
        },
        handleClose() {
            this.orgVisible = false;
            this.priceVisible = false;
        },
        //确定
        submit() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    if (this.isAdd == 1) {
                        this.request.projectAdd(this.ruleForm).then((res) => {
                            if (res.code == 0) {
                                this.$message.success("新增成功");
                                setTimeout(() => {
                                    this.$emit("projectList");
                                    this.resetForm();
                                }, 1000);
                            }
                        });
                    } else {
                        this.request.projectEdit(this.ruleForm).then((res) => {
                            if (res.code == 0) {
                                this.$message.success("编辑成功");
                                setTimeout(() => {
                                    this.$emit("projectList");
                                    this.resetForm();
                                }, 1000);
                            }
                        });
                    }
                }
            });
        },
    },
};
</script>


<style scoped lang="scss">
.tree {
    height: 25vh;
    overflow: auto;
    width: 15vw;
    background: #F8F8FA;
}

.form-body {
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    background-color: white;
    overflow-y: auto;
}

.form-title {
    margin: 20px 0;
}

.body-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.body-title .title-right>div {
    display: inline-block;
    margin-left: 24px;
}

.body-title .title-right .title-back .el-button--text {
    color: rgba(0, 0, 0, 0.6);
}

.dialog-footer {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 560px;
    text-align: right;
}

.page-header {
    margin: 10px;
    padding-bottom: 10px;
    padding-top: 10px;
    padding-left: 20px;
    font-weight: bold;
    background-color: white;
}

.title {
    font-size: 18px;
    font-family: "microsoft yahei ui","microsoft yahei";
    font-weight: bold;
    color: #000000;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}

.back {
    font-size: 26px;
    margin-right: 16px;
    cursor: pointer;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.el-tree ::v-deep.el-tree-node>.el-tree-node__content {
    height: 40px;
}

.show-hide:hover :nth-child(2) {
    display: inline-block !important;
}

.dialog-footer {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 560px;
    text-align: left;

    > :nth-child(1) {
        width: 300px;
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        opacity: 1;
        padding: 0;
        background: #3456ff;
    }

    > :nth-child(2) {
        font-family: "microsoft yahei ui","microsoft yahei";
        font-size: 14px;
        color: #666666;
        margin-left: 56px;
    }
}
</style>